// Central Highcharts module initialization.
// Modules must be initialized in dependency order to guarantee correct
// behaviour in both dev (Vite) and production (Rolldown/Rollup) builds,
// where side-effect import ordering is not guaranteed by the bundler.
import Highcharts from 'highcharts'
import HighchartsXrange from 'highcharts/modules/xrange'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsExportData from 'highcharts/modules/export-data'

function initModule (mod) {
  if (typeof mod === 'function') mod(Highcharts)
  else if (mod && typeof mod.default === 'function') mod.default(Highcharts)
}

initModule(HighchartsXrange)
initModule(HighchartsExporting)
// export-data depends on exporting being composed first
initModule(HighchartsExportData)

export default Highcharts
